import React, { useState } from 'react';
import { Button, TimesButton } from '@fiverr-private/button';
import { DRAWER_CLOSE_BTN_ID } from '@fiverr-private/overlay/src/components/Drawer/constants';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { AppI18n } from '../../i18n';
import { useDiscardChanges } from './useDiscardChanges';

interface EditBriefCloseButtonProps {
  onClose?: () => void;
  briefId?: string;
}

const EditBriefCloseButton: React.FC<EditBriefCloseButtonProps> = ({ onClose, briefId }) => {
  const { setIsOpen, openDiscardModal } = useBriefCreationContext();
  const { hasBriefChanged } = useDiscardChanges();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const isEditMode = !!briefId;

  const handleCloseModal = () => {
    setIsConfirmModalOpen(false);
  };

  const closeDrawer = () => {
    setIsConfirmModalOpen(false);
    setIsOpen(false);
    onClose?.();
  };

  const handleCloseClick = () => {
    if (isEditMode && hasBriefChanged) {
      openDiscardModal();
      setIsOpen(false);
      onClose?.();
    } else if (!isEditMode) {
      setIsConfirmModalOpen(true);
    } else {
      closeDrawer();
    }
  };

  return (
    <>
      <Modal isOpen={isConfirmModalOpen} onClose={handleCloseModal}>
        <ModalContent>
          <ModalHeader>
            <AppI18n k="delete_modal.title" />
            <ModalCloseBtn />
          </ModalHeader>
          <ModalBody>
            <AppI18n k="delete_modal.description" />
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={handleCloseModal}>
              <AppI18n k="delete_modal.cancel" />
            </Button>
            <Button onClick={closeDrawer} colorScheme="red">
              <AppI18n k="delete_modal.delete" />
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <TimesButton size="md" theme="dark" onClick={handleCloseClick} />
    </>
  );
};

EditBriefCloseButton.displayName = 'DrawerCloseButton';

Object.assign(EditBriefCloseButton, {
  id: DRAWER_CLOSE_BTN_ID,
});

export default EditBriefCloseButton;
